import React from "react";
import { Stack, Box, Text, Heading, TextLink } from "@origin-digital/ods-core";
import ReadOnlyTextField from "../FormComponents/ReadOnlyTextField";

interface ReadOnlySecondaryAccountForPageTwoProps {
  secondaryFirstName: string;
  secondaryLastName: string;
  secondaryDateOfBirth: Date | null;
  secondaryPhone: string;
  secondaryEmail: string;
  addSecondaryToBills: boolean;
  formatDate: (date: Date | null) => string;
}

const ReadOnlySecondaryAccountForPageTwo: React.FC<
  ReadOnlySecondaryAccountForPageTwoProps
> = ({
  secondaryFirstName,
  secondaryLastName,
  secondaryDateOfBirth,
  secondaryPhone,
  secondaryEmail,
  addSecondaryToBills,
  formatDate,
}) => (
  <Stack space={["large", "xlarge"]}>
    <Heading variant="h4">Secondary account holder</Heading>
    <Text>
      A secondary account holder is someone who has full access to your account
      but is not financially responsible. This means that they can make
      enquiries about the account, update postal details, accept offers, close
      the account and arrange disconnection, but they cannot apply a concession
      in their name or request an abolishment.
    </Text>
    <Stack>
      {/* Name */}
      <ReadOnlyTextField
        label="Name"
        value={`${secondaryFirstName} ${secondaryLastName}`}
      />
      {/* End Name */}
      {/* DOB + Phone */}
      <Box
        display="flex"
        flexDirection={{
          xs: "column",
          sm: "row",
        }}
      >
        {/* Date of birth */}
        <ReadOnlyTextField
          label="Date of birth"
          value={formatDate(secondaryDateOfBirth)}
        />
        {/* End Date of birth */}
        {/* Phone */}
        <ReadOnlyTextField label="Phone" value={secondaryPhone} />
        {/* End Phone */}
      </Box>
      {/* End DOB + Phone */}
      {/* Email */}
      <ReadOnlyTextField label="Email" value={secondaryEmail} />
      {/* End Email */}
      <ReadOnlyTextField
        label="Add secondary account holder's name to Origin bill"
        value={addSecondaryToBills ? "Yes" : "No"}
      />
    </Stack>
    <Text variant="body-small" tone="neutralLight">
      You’ll need to let the joint account holder know that their information
      has been provided to us and tell them about our privacy and credit
      reporting statements which are available at{" "}
      <TextLink href="https://originenergy.com.au/privacy">
        originenergy.com.au/privacy
      </TextLink>
      .
    </Text>
  </Stack>
);

export default ReadOnlySecondaryAccountForPageTwo;
